import { module } from 'angular';

import { default as fileInputDirectiveName, FileInputDirective } from './file-input.directive';

export default module('contact.commons.toolbox.file-input', []).directive(fileInputDirectiveName, FileInputDirective).name;
